export default "__VITE_ASSET__D72eNXhq__"